(function () {
  'use strict';

  angular.module('app').component('bankDetail', BankDetailComponent());

  function BankDetailComponent() {
    return {
      bindings: {
        item: '=',
        mode: '<',
        onSavedItem: '&',
        onCanceledItem: '&',
        defaultLanguage: '<',
        additionalLanguages: '<',
      },
      controller: BankDetailCoontroller,
      controllerAs: 'vm',
      templateUrl: './app/ajs/banks/bank-detail/bank-detail.component.html',
    };
  }

  BankDetailCoontroller.$inject = [
    'UtilService',
    'BankService',
    'SessionService',
    'PaymentMethodService',

    // Angular downgraded service
    'chartAccountService',
  ];

  function BankDetailCoontroller(
    UtilService,
    BankService,
    SessionService,
    PaymentMethodService,

    // Angular downgraded service
    chartAccountService
  ) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    var fieldsDefinition = ['name', 'account_catalog_code', 'payment_method_ids'];

    vm.chartAccounts = [];
    vm.paymentMethods = [];

    // Methods
    vm.editBank = editBank;
    vm.cancelEdit = cancelEdit;
    vm.openTranslations = openTranslations;
    vm.saveBank = saveBank;
    vm.cancel = cancel;

    vm.$onInit = function () {
      if (vm.item.id) {
        // Edit
        setItemOptions(vm.item, vm.mode);
      } else {
        // New
        vm.createMode = true;

        vm.item = {
          company_id: SessionService.getSelectedAccountCompany().id,
        };
      }

      getChartAccounts();
      getPaymentMethods();
    };

    function setItemOptions(item, mode = '') {
      vm.createMode = false;
      vm.editMode = false;
      vm.viewMode = true;

      if (mode === 'edit') {
        editBank();
      }

      vm.originalItem = angular.copy(item); // store server data
    }

    function getChartAccounts() {
      let filterCriteria = chartAccountService.getFilterCriteria();
      filterCriteria.company_id = vm.item.company_id;
      filterCriteria.by_chart_account_types = 'Assets';

      vm.loadingChartAccounts = true;
      chartAccountService.getChartAccounts(filterCriteria).subscribe((response) => {
        let data = response.data.filter(
          (chartAccount) => chartAccount.chart_account_type.description === 'Bank and Cash'
        );
        vm.account_catalog_name = data.filter(
          (option) => vm.item.account_catalog_code === option.code
        )[0];
        if (vm.account_catalog_name) {
          vm.account_catalog_name = vm.account_catalog_name.name;
        }
        vm.chartAccounts = data;
        vm.loadingChartAccounts = false;
      });
    }

    function getPaymentMethods() {
      vm.filterCriteria = PaymentMethodService.getFilterCriteria();
      vm.filterCriteria = PaymentMethodService.getFilterCriteria();
      vm.filterCriteria.lang = vm.defaultLanguage;

      vm.loadingPaymentMethods = true;

      PaymentMethodService.getPaymentMethods(vm.filterCriteria).then(function (data) {
        vm.paymentMethods = data.items;
        vm.loadingPaymentMethods = false;
      });
    }

    function editBank() {
      vm.editMode = true;
      vm.viewMode = false;
    }

    function cancelEdit() {
      vm.item = vm.originalItem;
      setItemOptions(vm.item);
    }

    function openTranslations() {
      BankService.openBankTranslations(vm.item, vm.additionalLanguages);
    }

    // Create/Update
    function saveBank(isFormValid) {
      vm.formErrors = false;

      if (!isFormValid) {
        vm.serverErrors = [];
        vm.formErrors = true;

        return;
      }
      if (vm.UtilService.isFormDataChanged(vm.item, vm.originalItem, fieldsDefinition)) {
        vm.sendingForm = true;
        BankService.saveBank(vm.item, vm.defaultLanguage).then(function (data) {
          var response = data.response;

          if (data.status) {
            // Success
            setItemOptions(response);
            vm.onSavedItem({ item: response });
          } else {
            vm.serverErrors = vm.UtilService._showItemServerErrors(response.errors);
            vm.formErrors = true;
          }

          vm.sendingForm = false;
        });
      } else {
        cancel();
      }
    }

    function cancel() {
      /*if (vm.editMode) {
                vm.cancelEdit();
                return;
            }*/

      vm.onCanceledItem({ item: vm.item });
    }
  }
})();
